export const TEAM_MESSAGES = {
  SUBTEXT_ANSWERED_YES: 'Happy to talk further',
  SUBTEXT_ANSWERED_NO: 'Client has declined for now',
  SUBTEXT_DEFAULT: 'Need help with insurance and other services?',
};
